// Chakra Icons
import { BellIcon, SearchIcon } from "@chakra-ui/icons";
// Chakra Imports
import {
  Button,
  Flex,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  Avatar,
  Box,
  useToast,
} from "@chakra-ui/react";
// Custom Icons
import { ProfileIcon, SettingsIcon } from "components/Icons/Icons";
// Custom Components
import { ItemContent } from "components/Menu/ItemContent";
import SidebarResponsive from "components/Sidebar/SidebarResponsive";
import PropTypes from "prop-types";
import React from "react";
import { NavLink, useHistory } from "react-router-dom";
import routes from "routes.js";
import { useAuth } from "contexts/AuthContext";
import { signOut } from "firebase/auth";
import { auth } from "config/firebase";

export default function HeaderLinks(props) {
  const { variant, children, fixed, secondary, onOpen, ...rest } = props;
  const { currentUser, userProfile } = useAuth();
  const history = useHistory();
  const toast = useToast();

  // Chakra Color Mode
  let mainTeal = useColorModeValue("teal.300", "teal.300");
  let inputBg = useColorModeValue("white", "gray.800");
  let mainText = useColorModeValue("gray.700", "gray.200");
  let navbarIcon = useColorModeValue("gray.500", "gray.200");
  let searchIcon = useColorModeValue("gray.700", "gray.200");

  if (secondary) {
    navbarIcon = "white";
    mainText = "white";
  }
  const settingsRef = React.useRef();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast({
        title: "로그아웃 완료",
        description: "성공적으로 로그아웃되었습니다.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      history.push("/auth/signin");
    } catch (error) {
      console.error("로그아웃 오류:", error);
      toast({
        title: "오류",
        description: "로그아웃에 실패했습니다.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  return (
    <Flex
      pe={{ sm: "0px", md: "16px" }}
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      gap={4}
    >
      {currentUser && userProfile && (
        <Menu>
          <MenuButton>
            <Flex align="center" gap={2}>
              <Avatar size="sm" name={userProfile.name} bg="blue.500" />
              <Box display={{ base: "none", md: "block" }}>
                <Text fontSize="sm" fontWeight="bold" color={mainText}>
                  {userProfile.name}
                </Text>
                <Text fontSize="xs" color="gray.500">
                  {userProfile.role === 'admin' || userProfile.role === 'manager' ? '관리자' : '일반회원'}
                </Text>
              </Box>
            </Flex>
          </MenuButton>
          <MenuList>
            <MenuItem onClick={() => history.push('/admin/my-profile')}>
              <ProfileIcon color="gray.500" w="16px" h="16px" me="8px" />
              내 프로필
            </MenuItem>
            <MenuItem onClick={handleLogout} color="red.500">
              <Text>로그아웃</Text>
            </MenuItem>
          </MenuList>
        </Menu>
      )}
      
      <SidebarResponsive
        logoText={props.logoText}
        secondary={props.secondary}
        routes={routes}
        {...rest}
      />
      
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
